exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-1plfS{display:-webkit-box;display:-ms-flexbox;display:flex;border:1px solid #1fadff;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#1fadff;margin-bottom:40px;padding:14px 10px;background-color:rgba(31,173,255,.3098039216)}.content-__ps6{font-size:18px;margin:0 40px;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;text-align:center}.icon-3v-xf{font-size:24px;width:40px;height:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-negative:0;flex-shrink:0}.warning-10U2r{background-color:rgba(255,109,127,.24);border-color:#ff6d7f;color:#ff6d7f}", ""]);

// exports
exports.locals = {
	"container": "container-1plfS",
	"content": "content-__ps6",
	"icon": "icon-3v-xf",
	"warning": "warning-10U2r"
};